import {
  Component,
  ElementRef,
  EventEmitter,
  input,
  Input,
  Output,
  ViewChild
} from "@angular/core";
import { ButtonIconComponent } from "../button/button-icon/button-icon.component";

type TagButtonOptions = {
  icon: string;
};

@Component({
  selector: "snt-tag",
  template: "",
  standalone: false
})
export class TagComponent {
  @Input() value: string = "";
  @Input() size: "xs" | "sm" | "md" | "xl" | "lg" | null = null;
  @Input() class: string = "";

  @Input() buttonOptions: TagButtonOptions | undefined;

  disabled = input<boolean>(false);

  @Output() onClick: EventEmitter<void> = new EventEmitter<void>();
  @Output() onButtonClick: EventEmitter<ButtonIconComponent> =
    new EventEmitter<ButtonIconComponent>();

  onClickEmit($event: MouseEvent) {
    if (this.disabled()) {
      return;
    }

    $event.stopImmediatePropagation();
    this.onClick.emit();
  }
}
